module.exports = __webpack_public_path__ + "static/media/fansfirst-logo-smaller-fr.db2f8124.svg";